import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})

export class filterPipe implements PipeTransform {

  public transform(value: any, keys: string, term: string) {
    if (!term) return value;
      term = term.replace('(', '').replace(')', '').replace(/\*/g, '');
    return (value || []).filter((item: any) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(String(item[key]).replace('(', '').replace(')', '').replace(/\*/g, ''))));
    // return (value || []).filter((item: any) => keys.split(',').some(key => item.hasOwnProperty(key) && String(item[key]).includes(term)));

  }
}
